import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TreeSelectModule } from 'primeng/treeselect';
import { NrTreeselectAieaPropDirective } from './directives/nr-treeselect-aiea-prop.directive';
import { NrTreeSelectSelectedItemsPipe } from './pipes/nr-tree-select-selected-items.pipe';
import { INRSelect, selectionMode } from '../../interfaces/nr-select.interface';

@Component({
  selector: 'nr-treeselect',
  templateUrl: './nr-treeselect.component.html',
  standalone: true,
  imports: [
    TreeSelectModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NrTreeselectAieaPropDirective,
    NrTreeSelectSelectedItemsPipe,
  ],
})
export class NRTreeselectComponent {
  @Input() set config(config: INRSelect) {
    this.configData = config;
    this.setDefaultValue();
  }
  @Input() hasError = false;
  @Input() viewSelectedCount = 4;
  @Output() selectedDataEvent = new EventEmitter<Record<string, unknown>[]>();

  defaultConfig: INRSelect = {
    placeholder: 'Select',
    data: [],
    selectedItems: [],
    optionLabel: 'label',
    filter: false,
    showToggleAll: false,
    selectionMode: 'checkbox',
    isRequiredField: false,
  };
  configData!: INRSelect;
  filter = false;
  selectionMode: selectionMode = 'checkbox';
  isRequiredField = false;
  treeSelectFormControl = new FormControl('');

  validateFormControl(): void {
    this.treeSelectFormControl.markAsDirty({
      onlySelf: true,
    });
  }

  resetFormControl(): void {
    this.treeSelectFormControl.reset();
  }

  onNodeChange() {
    this.selectedDataEvent.emit(this.getSelectedList(this.configData.selectedItems));
  }

  getSelectedList(selectedList) {
    return selectedList.reduce((selectedlist, currentItem) => {
      if (!Object.hasOwn(currentItem, 'children')) {
        selectedlist.push(
          this.configData.optionValue ? currentItem[this.configData.optionValue] : currentItem,
        );
      }
      return selectedlist;
    }, []);
  }

  private setDefaultValue() {
    this.filter = (this.configData.filter ?? this.defaultConfig.filter) as boolean;
    this.configData.showToggleAll = (this.configData.showToggleAll ??
      this.defaultConfig.showToggleAll) as boolean;
    this.selectionMode = (this.configData.selectionMode ??
      this.defaultConfig.selectionMode) as selectionMode;
    this.configData.label = this.configData.label ?? this.defaultConfig.label;
    this.configData.placeholder = this.configData.placeholder ?? this.defaultConfig.placeholder;
    this.configData.selectedItems =
      this.configData.selectedItems ?? this.defaultConfig.selectedItems;
    this.configData.optionLabel = this.configData.optionLabel ?? this.defaultConfig.optionLabel;
    this.configData.optionValue = this.configData.optionValue ?? this.defaultConfig.optionValue;
    this.isRequiredField = (this.configData.isRequiredField ??
      this.defaultConfig.isRequiredField) as boolean;
    this.treeSelectFormControl = this.configData.frmControl ?? this.treeSelectFormControl;
  }
}
